import { useGsapReveal } from "../../hooks/useGsapReveal";

export default function FadeInSection({
  children,
  className = "",
  y = 36,
  x = 0,
  duration = 0.85,
  delay = 0,
  stagger = 0,
  start = "top 88%",
  immediate = false,
  ease = "power2.out",
}) {
  const ref = useGsapReveal({
    y,
    x,
    duration,
    delay,
    stagger,
    start,
    immediate,
    ease,
  });

  return (
    <div ref={ref} className={className}>
      {children}
    </div>
  );
}
